var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["maxlength"];
import { ref, watch, nextTick, onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'yc-code',
    props: {
        codeLength: {
            type: Number,
            default: 4
        }
    },
    emits: ['complete'],
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        // 真实输入框数据
        var realCode = ref('');
        // 可视化数据
        var codeData = ref([]);
        // 隐藏的真实输入框引用
        var realInputRef = ref();
        // 当前激活的索引
        var currentIndex = ref(0);
        // 输入框激活状态
        var realInputActive = ref(false);
        // 处理容器点击
        var handleContainerClick = function () {
            var _a;
            realInputActive.value = true;
            (_a = realInputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        // 处理输入
        var handleInput = function () {
            // slice(0, props.codeLength).split('')
            // 修改后：强制按顺序填充
            var newCode = realCode.value;
            console.log(newCode, '你是是');
            // codeData.value = Array.from({ length: props.codeLength }, (_, i) => newCode[i] || '')
            codeData.value = Array.from(newCode);
            currentIndex.value = Math.min(realCode.value.length, props.codeLength - 1);
            if (realCode.value.length === props.codeLength) {
                emit('complete', realCode.value);
            }
        };
        // 处理删除
        var handleDelete = function (e) {
            if (realCode.value.length === 0) {
                currentIndex.value = 0;
                return;
            }
            // 仅在内容为空时处理删除
            if (!realCode.value[currentIndex.value]) {
                e.preventDefault();
                var newCode = realCode.value.slice(0, -1);
                realCode.value = newCode;
                codeData.value = newCode.split('');
                currentIndex.value = Math.max(0, newCode.length - 1);
            }
        };
        // 保持光标位置同步
        watch(currentIndex, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        if (realInputRef.value) {
                            realInputRef.value.selectionStart = currentIndex.value;
                            realInputRef.value.selectionEnd = currentIndex.value;
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        // 新增组合输入处理
        watch(realCode, function (newVal) {
            if (newVal.length > props.codeLength) {
                realCode.value = newVal.slice(0, props.codeLength);
            }
        });
        var init = function () {
            var _a;
            currentIndex.value = 0;
            codeData.value = Array(props.codeLength).fill('');
            realCode.value = '';
            (_a = realInputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            realInputActive.value = true;
        };
        // 初始化
        onMounted(function () {
            init();
        });
        __expose({
            init: init
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "verify-code-wrapper",
                onClick: handleContainerClick
            }, [
                _withDirectives(_createElementVNode("input", {
                    ref_key: "realInputRef",
                    ref: realInputRef,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((realCode).value = $event); }),
                    type: "numtber",
                    pattern: "[0-9]*",
                    class: "hidden-input",
                    maxlength: __props.codeLength,
                    onInput: handleInput
                }, null, 40, _hoisted_1), [
                    [_vModelText, realCode.value]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.codeLength, function (_, index) {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["code-item", { 'active': realInputActive.value && index === currentIndex.value }])
                    }, _toDisplayString(codeData.value[index] || ''), 3));
                }), 128))
            ]));
        };
    }
});
